module.exports = __webpack_public_path__ + "static/media/D11.e4163ae3.png";